import joseEmanuel from "../images/results/joseEmanuel.jpg"
import joseEmanuelWebp from "../images/results/joseEmanuel.webp";
import joseManuel from "../images/results/joseManuel.jpg"
import joseManuelWebp from "../images/results/joseManuel.webp"
import alessioRossi from "../images/results/alessioRossi.jpg"
import alessioRossiWeb from "../images/results/alessioRossi.webp";
import mikhaelPacheco from "../images/results/mikhaelPacheco.jpg"
import mikhaelPachecoWebp from "../images/results/mikhaelPacheco.webp";
import deissyCastillo from "../images/results/deissyCastillo.jpg";
import deissyCastilloWebp from "../images/results/deissyCastillo.webp";
import jorgeBenitez from "../images/results/jorgeBenitez.jpg"
import jorgeBenitezWebp from "../images/results/jorgeBenitez.webp";
import carlitosAcevedo from "../images/results/carlitosAcevedo.jpg";
import carlitosAcevedoWebp from "../images/results/carlitosAcevedo.webp";



const features = [
    {
        video: "https://www.youtube.com/watch?v=d93KEZs8Ewg",
        image: joseEmanuel,
        imageWebp: joseEmanuelWebp,
        name: "Jose Emanuel",
        country: "Chile",
    },

    {
        video: "https://www.youtube.com/watch?v=flEz66qXrcs",
        image: joseManuel,
        imageWebp: joseManuelWebp,
        name: "Jose Manuel",
        country: "Colombia",
    },

    {
        video: "https://www.youtube.com/watch?v=47VjKsfjmtk",
        image: alessioRossi,
        imageWebp: alessioRossiWeb,
        name: "Alessio Rossi",
        country: "Italia",
    },

    {
        video: "https://www.youtube.com/watch?v=Qv9FGcObJgs",
        image: mikhaelPacheco,
        imageWebp: mikhaelPachecoWebp,
        name: "Miguel Pacheco",
        country: "Estados Unidos",
    },

    {
        video: "https://www.youtube.com/watch?v=Eivej6HMYG",
        image: deissyCastillo,
        imageWebp: deissyCastilloWebp,
        name: "Deissy Castillo",
        country: "Colombia",
    },

    {
        video: "https://www.youtube.com/watch?v=jJf9lpZfd_M",
        image: jorgeBenitez,
        imageWebp: jorgeBenitezWebp,
        name: "Jorge Benítez",
        country: "México",
    },

    {
        video: "https://www.youtube.com/watch?v=d0MyVfez1tw",
        image: carlitosAcevedo,
        imageWebp: carlitosAcevedoWebp,
        name: "Carlos Acevedo",
        country: "Colombia",
    },
];

export default features;
